import React, { useState } from "react";
import { Modal } from "react-bootstrap";

export default function AppModal({
  header,
  body,
  footer,
  closeButton,
  visible,
  onHide,
  size,
  centered = true,
  headerStyle,
  model,
  bodyStyle = { overflowY: "auto" },
}) {
  const [show, setShow] = useState(visible);
  const handleClose = () => setShow(false);

  return (
    <Modal
      scrollable={true}
      show={show || visible}
      onHide={() => {
        handleClose();
        onHide && onHide({ visible: false });
      }}
      backdrop="static"
      keyboard={false}
      size={size || "lg"}
      centered={centered || false}
      className="dial"
    >
      {model}

      <Modal.Header style={{ height: 60, ...headerStyle }} closeButton>
        {header}
      </Modal.Header>

      {body && <Modal.Body style={bodyStyle}>{body}</Modal.Body>}
      {footer && <Modal.Footer style={{ height: 60 }}>{footer}</Modal.Footer>}
    </Modal>
  );
}
